import { useEffect } from 'react';

/**
 * Hook to set CSS custom property --vh for 100vh fallback
 * Handles iOS Safari viewport changes when address bar shows/hides
 * Use this in combination with height: calc(var(--vh, 1vh) * 100) or just rely on dvh
 */
export function useViewportHeight() {
  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    // Set initial value
    setVH();

    // Update on resize and orientation change
    window.addEventListener('resize', setVH);
    window.addEventListener('orientationchange', setVH);

    // iOS Safari specific: update when keyboard shows/hides
    // visualViewport is more accurate for mobile keyboard detection
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', setVH);
    }

    return () => {
      window.removeEventListener('resize', setVH);
      window.removeEventListener('orientationchange', setVH);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', setVH);
      }
    };
  }, []);
}
